/**
 * Simple ordered process block for service pages / homepage.
 */
export default function ProcessSteps({
  eyebrow = "How it works",
  title = "Our service process",
  intro,
  steps = [],
  bg = "white",
}) {
  const wrap = bg === "slate" ? "bg-slate-50 border-y border-slate-200" : "bg-white";
  return (
    <section className={`fss-section ${wrap}`} data-testid="process-steps">
      <div className="fss-container">
        <div className="max-w-3xl mb-12">
          <div className="fss-overline">{eyebrow}</div>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
            {title}
          </h2>
          {intro && (
            <p className="mt-3 text-slate-600 leading-relaxed">{intro}</p>
          )}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {steps.map((s, i) => (
            <div
              key={i}
              className="bg-white p-7"
              data-testid={`process-step-${i}`}
            >
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center bg-green-700 text-white text-sm font-display font-bold rounded-sm">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display text-lg font-semibold text-slate-900">
                  {s.title}
                </h3>
              </div>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                {s.copy}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
